import axios from "axios";
const baseDomain = process.env.VUE_APP_URL_BACKEND_BOTAPI;
const baseURL = `${baseDomain}/owner`;
export default axios.create({ baseURL });
